module.exports = __webpack_public_path__ + "static/media/dxchange.b81cbd2a.png";